import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
const useStyles = makeStyles((theme) => {
  return {
    mainAboutusContainer: {
      marginTop: 20,
      paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
      paddingRight: theme.spacing(myTheme.padding.right + 3.4),
      marginBottom: 30,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        //marginLeft:'15%'
      },
    },
    bCrumbLink: {
      "text-decoration": "none",
      color: "#666",
      "&:hover": {
        color: "black",
        "text-decoration": "none",
      },
    },
    mainStoreContainer: {},
    storeImage: {
      width: 300,
      height: 200,
      objectFit: "cover",
      backgroundRepeat: "no-repeat",
      backgroundColor: "#ffcccb",
      backgroundSize: "contain",
      backgroundPosition: "right",
      position: "relative",
      //   display: "flex",
      //   justifyContent: "right",
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        visibility: "hidden",
        display: "none",
        //marginLeft:'15%'
      },
    },
    storeBanner: {
      backgroundColor: "#ffcccb",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    storeTitle: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: 25,
      backgroundColor: "#fff",
      margin: 10,
      borderRadius: 5,
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
      maxWidth: 400,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: "100%",
      },
    },
    chatBtn: {
      color: myTheme.palette.primary.main,
      // "&:hover": {
      //   backgroundColor:'#e9e9e9',
      // },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: "50%",
      },
    },
    storetabs: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    ".PrivateTabIndicator-colorSecondary-41": {
      backgroundColor: "#fff",
    },
    homePageTabMainProductImg: {
      maxWidth: 220,
      maxHeight: 240,
      objectFit: "cover",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        maxWidth: "100%",
        marginTop: 5,
        maxHeight: 140,
      },
    },
    ".MuiBox-root-66": {
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        padding: 5,
      },
    },
    mainProductText: {
      fontWeight: "bold",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        maxWidth: "100%",
      },
    },
    ".MuiBox": {
      padding: 0,
    },
    TabBox: {
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        padding: 2,
      },
    },
    homePageTabMainProduct: {
      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      "&:hover": {
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      },
      marginRight: 10,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        display: "flex",
        maxWidth: "100%",
        maxHeight: 250,
        marginBottom: 10,
        marginRight: 0,
      },
    },
    storeFrontProductsMainDiv: {
      display: "flex",
      marginTop: 20,
      justifyContent: "space-between",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection: "column",
      },
    },
    topProductsForText:{
      paddingTop: 5,
      paddingBottom: 20 ,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width:'100%',
        textAlign:'center',
        alignItems:'center',
        justifyContent:'center'
      },
    },
    allProductsDiv: {
      
      marginTop: 40,
      marginBottom: 5,
      display: "flex",
      justifyContent: "center",
      margin: "auto",
      flexDirection: "column",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        padding: 0,
        margin:0,
        marginTop:20
      },
    },
    homePageTabSubProductImg: {
      maxWidth: 160,
      maxHeight: 140,
      objectFit: "cover",
      padding: 5,
      marginLeft: 5,
    },
    subLandsProduct: {
      display: "flex",
      alignItems: "center",
      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
      "&:hover": {
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      },

      overflow: "hidden",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection: "column",
      },
    },
    subProductText: {
      fontWeight: "bold",
      paddingRight: 2,
      maxWidth: 190,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        maxWidth: "100%",
        paddingRight: 0,
      },
    },
    subProductTextDiv: {
      maxWidth: 200,
      padding: 10,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
    },
    priceText: {
      color: myTheme.palette.primary.main,
    },
    portraitProduct: {
      alignItems: "center",
      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
      "&:hover": {
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      },
      width: 190,
      padding: 5,
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      whiteSpace: "nowrap",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: "48.5%",
      },
    },
    portraitProductsContainer: {
      display: "flex",
      justifyContent: "space-between",
      paddingRight: 0,
      paddingBottom: 0,
      marginTop: 4,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        marginTop: 8,
      },
    },
    badge: {
      backgroundColor: myTheme.palette.primary.main,
      color: "#fff",
      maxWidth: 120,
      paddingLeft: 3,
      paddingRight: 3,
      borderRadius: 30,
      fontSize: 13,
    },
    productsMainGrid: {
      display: "flex",
      justifyContent: "flex-start",
      borderTop: "0.1px solid #e9e9e9",
      paddingTop: 17,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        justifyContent: "center",
      },
    },
    infoDiv:{
      display:'flex',
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection:'column',
        justifyContent:'center',
        width:'100%',
        marginRight:0
      },
      
    },
    //for profile info
    profileInfoBox: {
      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
      padding: 30,
      display: "flex",
      margin: 10,
      minWidth: 220,
      minHeight: 160,
      maxWidth: 300,
      maxHeight: 200,
      flexDirection: "column",
      alignItems: "center",
      "&:hover": {
        color: myTheme.palette.primary.main,
      },
      reviewVerificationAndTimeBox: {
        [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
          display: "flex",
          flexDirection: "column",
        },
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width:'100%',
        alignItems:'center',
        display:'flex',
        marginRight:0,
        maxWidth:'95%'
      },
    },
    starsBox:{
      padding:8,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        padding:0
      },
    },
    numberedRatingsStarsBox: {
      display: "flex",
      flexDirection: "column",
      margin: "auto",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        margin: 0,
        marginTop: 14,
        display: "block",
      },
    },
    AvgRatingsBoxes: {
      display: "flex",
      flexDirection: "row",
      borderBottom: "0.2px solid #e9e9e9",
      paddingBottom: 30,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        flexDirection: "column",
      },
    },
    bioBox: {
      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
      padding: 20,
      margin: 10,
      display: "flex",
      width: "100%",
      flexDirection: "column",
    },
    InfoIcon: {
      fontSize: 50,
    },
  };
});

export default useStyles;
